import { render } from "./WithdrawPopup.vue?vue&type=template&id=f8b52be2&scoped=true&ts=true"
import script from "./WithdrawPopup.vue?vue&type=script&lang=ts"
export * from "./WithdrawPopup.vue?vue&type=script&lang=ts"

import "./WithdrawPopup.vue?vue&type=style&index=0&id=f8b52be2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8b52be2"]])

export default __exports__